/** Existing customer support route used by the SSO setup flow. */
export const SUPPORT_EMAIL = "support@devskiller.com";
